const config = require("../config.js");
const UTILS = require("../libs/utils.js");
module.exports = function (Game, i18n) {
  var GUI = {
    _html: {
      settings: {
        input: {
          generic: function (p9951, p9952) {
            p9952 = p9952 || "window";
            return "<input type='" + p9951.type + "' name='" + p9951.type + "' id='slid_" + p9951.key + "' class='inputGrey2' placeholder='" + p9951.placeholder + "'\n\t\t\t\t\t\t\tvalue='" + p9951.val + "' oninput='" + p9952 + ".setSetting(\"" + p9951.key + "\", this.value)'/>";
          },
          color: function (p9953, p9954) {
            p9954 = p9954 || "window";
            return "<input type='color' name='color' id='slid_" + p9953.key + "' style='float:right' value='" + p9953.val + "'\n\t\t\t\t\t\t\toninput='" + p9954 + ".setSetting(\"" + p9953.key + "\", this.value)'/>";
          },
          switch: function (p9955, p9956) {
            p9956 = p9956 || "window";
            return "<label class='switch' style='margin-left:10px'><input type='checkbox' onclick='" + p9956 + ".setSetting(\"" + p9955.key + "\", this.checked)'\n\t\t\t\t\t\t\t" + (p9955.val ? "checked" : "") + "><span class='slider'><span class='grooves'></span></span></label>";
          },
          slider: function (p9957, p9958) {
            p9958 = p9958 || "window";
            return "<input type='number' class='sliderVal' id='slid_input_" + p9957.key + "' min='" + p9957.min + "' max='" + p9957.max + "'\n\t\t\t\t\t\t\tvalue='" + p9957.val + "' onkeypress='return " + p9958 + ".delayExecute(\"" + p9957.key + "\", this, " + p9957.delay + ")' style='margin-right:0px;border-width:0px'/>\n\t\t\t\t\t\t\t<div class='slidecontainer' style='margin-top: -8px;" + (p9957.style || "") + "'><input type='range' id='slid_" + p9957.key + "' min='" + p9957.min + "' max='" + p9957.max + "' step='" + p9957.step + "'\n\t\t\t\t\t\t\tvalue='" + p9957.val + "' class='sliderM' oninput='" + p9958 + ".setSetting(\"" + p9957.key + "\", this.value)'></div>";
          },
          select: function (p9959, p9960, p9961) {
            p9960 = p9960 || "window";
            p9961 = p9959.options || p9961;
            return "<select onchange='" + p9960 + ".setSetting(\"" + p9959.key + "\", this.value)' class='inputGrey2'>\n\t\t\t\t\t\t\t" + Object.keys(p9961).map(p9962 => "<option value='" + p9962 + "' " + (p9962 == p9959.val ? "selected" : "") + ">" + p9961[p9962] + "</option>") + "</select>";
          }
        }
      }
    },
    endScreen: {
      tabs: {
        leaderboard: {
          name: "Leaderboard",
          gen: function () {
            requestAnimationFrame(this.showTable);
            return "<table id=\"endTable\"></table>";
          }
        },
        performance: {
          name: "Performance",
          mode: {
            ids: ["ffa", "tdm", "ctf", "kc", "point"],
            getIcon: function () {
              if (this.ids.includes(Game.mode.id)) {
                return "<img src=\"" + UTILS.assetsUrl("img/modes/" + Game.mode.id + ".png") + "\" class=\"modeIcon\">";
              } else {
                return "<div class=\"unknownModeIcon\">?</div>";
              }
            }
          },
          xp: {
            animTime: 1000,
            newScoreCol: "#fff",
            getNewScoreProg: function (p9963, p9964) {
              let v7991 = p9963.level > 1 ? Math.pow(p9963.level / config.rankVar, 2) : 0;
              let vParseInt21 = parseInt(Math.pow((p9963.level + 1) / config.rankVar, 2) - v7991);
              return p9964 / vParseInt21 * 100;
            },
            animateXPBar: function (p9965, p9966) {
              let v7992 = document.getElementsByClassName("xpEndBarB")[p9966];
              if (v7992) {
                v7992.style.width = p9965 + "%";
              }
            }
          },
          gen: function () {
            let {
              rank: Iîiïîîî,
              score: Iïìïîíì,
              kills: Iìííìií,
              deaths: Iïiïïìí,
              funds: Iiìîïïî,
              victory: Iìîiïîi,
              endInd: Iìiiiîi
            } = this.stats;
            let v7993 = (this.account ? this.account.wins / this.account.games : Iìîiïîi == -1 ? 0 : Iìîiïîi ? 1 : 0).toFixed(2);
            let v7994 = "<div class=\"endTitle\" style=\"text-align:center\">" + Game.mode.name + "</div>\n\t\t\t\t\t\t\t<div id=\"modeLayout\">" + this.mode.getIcon() + "\n\t\t\t\t\t\t\t<div class=\"modeStatus\" style=\"margin-top: -5px;" + (Iìîiïîi == -1 ? "color:var(--yellow)" : Iìîiïîi ? "" : "color:var(--red)") + "\">\n\t\t\t\t\t\t\t" + (Iìiiiîi == 3 ? "CANCELLED" : Iìîiïîi == -1 ? "DRAW" : Iìîiïîi ? "VICTORY" : "DEFEAT") + "</div></div>";
            let v7995 = "<div id=\"fundsLayout\" style=\"" + (Game.mode.ranked ? "zoom:0.8" : "") + "\">\n\t\t\t\t\t\t\t<div class=\"fundsVal\">" + (Iiìîïïî == "NONE" ? "NONE" : Iiìîïïî) + "</div></div>";
            let vLS28 = "";
            if (this.account && !this.isCustom && this.bpData) {
              this.bpData = this.bpData || {
                bpp: 0,
                mx: 1
              };
              let v7996 = (this.bpData.bpp || 0) % this.bpData.mx;
              let v7997 = v7996 / this.bpData.mx * 100;
              let v7998 = Math.floor((this.bpData.bpp || 0) / this.bpData.mx) + 1;
              let v7999 = v7998 >= this.bpData.ml;
              if (v7999) {
                v7996 = this.bpData.mx;
                v7997 = 100;
                v7998 = this.bpData.ml;
              }
              let v8000 = v7999 ? this.account.BP.tier > 0 ? "VIP Tier Complete" : "Free Tier Complete" : "Next Level Reward";
              let v8001 = !v7999 && !(this.account.BP.tier > 0);
              let v8002 = this.bpData.re;
              let vLSimgbattlepasslogo_wh = "./img/battlepass/logo_white.svg";
              if (v8002) {
                vLSimgbattlepasslogo_wh = v8002.kr ? "./img/battlepass/krunkies.svg" : v8002.sk ? Game.store.skins[v8002.sk].thumbnail : "";
              }
              if (v7999) {
                vLSimgbattlepasslogo_wh = "./img/battlepass/logo_0.png";
              }
              vLS28 += "<div id='endBPLayout'>\n\t\t\t\t\t\t\t\t<div class=\"endSection\" style=\"margin-bottom:10px\">\n\t\t\t\t\t\t\t\t\t<div class='endTitle'>\n\t\t\t\t\t\t\t\t\t\tBattle Pass\n\t\t\t\t\t\t\t\t\t\t<img class=\"endBpInfo\"  onmouseenter=\"playTick()\" onclick=\"playSelect();showWindow(6)\" src=\"./img/frvr-ui/info-icon.svg\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div id='endBPLvl'>Level " + v7998 + "</div>\n\t\t\t\t\t\t\t\t\t<div class=\"blackShad\" id='endBPGained'>+" + ((this.bpData.gn || 0) + (this.bpData.cbp || 0)) + "</div>\n\t\t\t\t\t\t\t\t\t<div class=\"blackShad\" id='endBPProgText'>" + (v7996 + "/" + (this.bpData.mx || 0)) + "</div>\n\t\t\t\t\t\t\t\t\t<div class='xpEndBar' style='margin-top: 19px;margin-bottom: 0px;'>\n\t\t\t\t\t\t\t\t\t\t<div class='xpEndBPBarB' style='width: " + v7997 + "%;'></div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div id=\"endBPUnlock\" onmouseenter=\"playTick(0.1);\" style=\"display:" + (this.account.BP.tier > 0 ? "none" : "block") + "\" onclick=\"playSelect(0.1);windows[5].purchasePop();\">Unlock VIP</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"endBPNext\">\n\t\t\t\t\t\t\t\t\t<div id='endBPNextText'>" + v8000 + "</div>\n\t\t\t\t\t\t\t\t\t<img id=\"endBPLogo\" src=\"./img/battlepass/logo_white.svg\"" + (v7999 ? " style=\"visibility:hidden\"" : "") + ">\n\t\t\t\t\t\t\t\t\t<div id=\"endBPReward\" style=\"display: " + (v8002 || v7999 ? "block" : "none") + ";\">\n\t\t\t\t\t\t\t\t\t\t<img id=\"endBPRewardImg\" src=\"" + vLSimgbattlepasslogo_wh + "\">\n\t\t\t\t\t\t\t\t\t\t<img id=\"endBPRewardLock\" src=\"./img/battlepass/lock.png\" style=\"display:" + (v8001 ? "block" : "none") + ";\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>";
            }
            vLS28 += "<div id='endLayout'><div><div id='gameFundsLayout'><div class='gfSection' style='margin-bottom: 0px;padding: 16px 0px;'>" + v7994 + "</div><div class='gfSection'>" + v7995 + "</div></div></div><div class='endSection'><div class='endTitle'>Combat Record</div><div id='combatRecordLayout'><div class='crStat'><div class='crLabel'>Score</div><div class='crVal'>" + Iïìïîíì + "</div></div><div id='kdLayout'><div class='crStat'><div class='crLabel'>Kills</div><div class='crVal'>" + Iìííìií + "</div></div><div class='crStat'><div class='crLabel'>Deaths</div><div class='crVal'>" + Iïiïïìí + "</div></div></div><div class='crStat'><div class='crLabel'>Rank</div><div class='crVal'>" + Iîiïîîî + "</div></div><div class='crStat'><div class='crLabel'>SPK</div><div class='crVal'>" + (Iïìïîíì / (Iìííìií || 1) || 0).toFixed(2) + "</div></div><div class='crStat'><div class='crLabel'>KDR</div><div class='crVal'>" + (Iìííìií / (Iïiïïìí || 1) || 0).toFixed(2) + "</div></div><div class='crStat'><div class='crLabel'>W/L</div><div class='crVal'>" + v7993 + "</div></div></div></div></div>";
            if (this.account) {
              this.account.updateLevel();
              let v8003 = this.xp.getNewScoreProg(this.account, Iïìïîíì);
              let v8004 = this.account.levelProg;
              let v8005 = v8004 > 100;
              let v8006 = "<div id='lvlLayout'><img src='" + UTILS.assetsUrl("/img/levels/" + UTILS.levelIconId(this.account.level) + ".png") + "' class='xpRnk'><div class='xpLvl'>" + this.account.level + "</div><div class='xpEndBar'><div class='xpEndBarB' style='width: 0%;" + (v8005 ? "background-color:" + this.xp.newScoreCol : "") + "'></div><div class='xpEndBarB' style='width: 0%;background-color: " + this.xp.newScoreCol + ";margin-left: -7px;'></div><span class='xpEndBarV blackShad'>" + UTILS.xpBarText(this.account) + "</span></div><img src='" + UTILS.assetsUrl("/img/levels/" + UTILS.levelIconId(this.account.level) + ".png") + "' class='xpRnk' style='margin-left: auto'><div class='xpLvl'>" + (this.account.level + 1) + "</div></div>";
              vLS28 += "<div class=\"endSection\" style=\"margin-top:10px\">" + v8006 + "</div>";
              requestAnimationFrame(() => {
                this.xp.animateXPBar(v8005 ? v8004 % 100 : v8004 - v8003, 0);
              });
              if (!v8005) {
                requestAnimationFrame(() => {
                  this.xp.animateXPBar(v8003, 1);
                }, this.xp.animTime);
              }
            }
            return vLS28;
          }
        },
        medals: {
          name: "Medals",
          gen: function () {
            var v8007 = this.list || [];
            if (!v8007 || !v8007.length) {
              return "<div style=\"text-align:center;color:#fff;font-size:30px;background-color:rgba(0, 0, 0, 0.4);border-radius:6px;padding:20px;\">You didnt earn any medals this game!</div>";
            }
            let vLSdivIdmedalTable = "<div id='medalTable'>";
            var v8008;
            for (var vLN01297 = 0; vLN01297 < v8007.length; vLN01297++) {
              v8008 = "background-image: url(" + UTILS.assetsUrl("/img/medals/medal_" + v8007[vLN01297].i + ".png") + "), url(" + UTILS.assetsUrl("/img/medals/badge_0.svg") + ")";
              vLSdivIdmedalTable += "<div class='medalCard'><div class='medalImg' style='" + v8008 + "'></div><div class='medalTxt'>" + v8007[vLN01297].n + "</div><div class='medalTxt'>x" + v8007[vLN01297].c + "</div></div>";
            }
            vLSdivIdmedalTable += "</div>";
            return vLSdivIdmedalTable;
          }
        },
        rewards: {
          name: "Rewards",
          gen: function () {
            var v8009 = this.list || {};
            if (!v8009.junk && !v8009.skins) {
              return "<div style=\"text-align:center;color:#fff;font-size:30px;background-color:rgba(0, 0, 0, 0.4);border-radius:6px;padding:20px;\">You didnt earn any rewards this game!</div>";
            }
            let vLSdivIdrewardTable = "<div id='rewardTable'>";
            let vA393 = [];
            if (v8009.junk) {
              vLSdivIdrewardTable += "<div class='rewItemHolder' style='border: 2px solid " + Game.store.rarities[2].color + ";'><img draggable='false' class='rewJunkImg' loading='lazy' src='" + UTILS.assetsUrl("/img/frvr-ui/junk-symbol.svg", undefined, true) + "'><div class='rewItemN'>" + parseFloat(v8009.junk).toFixed(2) + " Junk</div></div>";
            }
            if (v8009.skins) {
              for (var vLN01299 = 0; vLN01299 < v8009.skins.length; vLN01299++) {
                tmpObj = Game.store.skins[v8009.skins[vLN01299].i];
                if (tmpObj) {
                  vLSdivIdrewardTable += "<div class='rewItemHolder' style='border: 2px solid " + Game.store.rarities[tmpObj.rarity].color + ";' onclick='viewItem(" + tmpObj.index + ")'>" + (tmpObj.type && tmpObj.type == 4 ? "<div class='rewItemSprayImg' style='background: url(&quot;" + tmpObj.thumbnail + "&quot;);" + UTILS.getFrameAnim(tmpObj, "sprayAnmD") + "'></div>" : "<img draggable='false' class='" + (tmpObj.type == 16 ? "rewCardImg" : "rewItemImg") + "' loading='lazy' src='" + tmpObj.thumbnail + "'>") + "<div class='rewItemN'>" + tmpObj.name + "</div><div class='rewItemCnt'>x" + v8009.skins[vLN01299].c + "</div></div>";
                  if (tmpObj.type && tmpObj.type == 4 && tmpObj.frames && vA393.indexOf(tmpObj.frames) == -1) {
                    vA393.push(tmpObj.frames);
                  }
                }
              }
            }
            vLSdivIdrewardTable += "</div>";
            if (vA393.length) {
              vLSdivIdrewardTable += "<style>";
              for (var vLN01299 = 0; vLN01299 < vA393.length; vLN01299++) {
                vLSdivIdrewardTable += "@keyframes sprayAnmD" + vA393[vLN01299] + " {100%{background-position:-" + vA393[vLN01299] * 120 + "px}}";
              }
              vLSdivIdrewardTable += "</style>";
            }
            return vLSdivIdrewardTable;
          }
        }
      },
      init: function (p9967, p9968, p9969, p9970, p9971, p9972, p9973, p9974, p9975, p9976) {
        this.spectating = p9968;
        this.hasVoting = p9973;
        this.account = p9967;
        this.isCustom = p9972;
        this.clicked2XP = false;
        requestAnimationFrame(p9975);
        this.tabs.leaderboard.showTable = p9976;
        this.tabs.performance.account = p9967;
        this.tabs.performance.stats = p9969;
        this.tabs.performance.isCustom = p9972;
        this.tabs.performance.bpData = p9974;
        this.tabs.medals.list = p9970;
        this.tabs.rewards.list = p9971;
        this.changeTab(this.spectating || p9972 ? "leaderboard" : "performance");
      },
      changeTab: function (p9977) {
        this.currentTab = p9977;
        this.show();
      },
      show: function () {
        let vLS29 = "";
        if (!this.spectating) {
          vLS29 += "<div id='tabHolder'>";
          for (let v8010 in this.tabs) {
            vLS29 += "<div class=\"tabHeader " + (v8010 == this.currentTab ? "selected" : "") + "\"\n\t\t\t\t\t\tonmouseenter=\"playTick()\" onclick=\"GUI.endScreen.changeTab('" + v8010 + "')\">" + this.tabs[v8010].name + "</div>";
          }
          vLS29 += "</div>";
        }
        let v8011 = "<div class=\"endCard\">" + vLS29 + "\n\t\t\t\t\t<div class=\"tabBody\"" + (this.hasVoting ? " style=\"max-height:545px\"" : "") + ">" + this.tabs[this.currentTab].gen() + "</div></div>";
        if (Game.isComp) {
          v8011 += "<div id=\"returnHolder\" onclick=\"openURL(location.origin, true)\">\n\t\t\t\t\t\t<div id=\"returnText\">Return to Krunker</div>\n\t\t\t\t\t</div>";
        } else if (!this.clicked2XP && this.account && this.account.id && this.account.games % 3 == 0 && this.account.games != 0 && !this.isCustom) {
          v8011 += "<div id=\"doubleXPHolder\" onmouseenter=\"playTick(0.1);\" onclick=\"showDoubleXPRewardedAd()\">\n\t\t\t\t\t\t<img style=\"vertical-align: middle;display:inline\" height=\"60px\" src=\"./img/frvr-ui/ad-icon.svg\">\n\t\t\t\t\t\t<div id=\"returnText\">" + i18n.t("window.endgame.player.doubleGainedXP") + "</div>\n\t\t\t\t\t</div>";
        }
        endTabbedView.innerHTML = v8011;
      }
    }
  };
  window.GUI = UTILS.removePrivateKeys(GUI);
  return GUI;
};